<template>
    <b-modal id="modal-no-claims" centered size="lg" v-model="isOpen">
        <template v-slot:modal-header="{ close }">
            <img src="./../../images/sbl-logo-blue.png" alt="Sbl Logo" width="250px">
            <!-- Emulate built in modal header close button action -->
            <button type="button" aria-label="Close" class="close" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path stroke="#B7B7B7" d="M338.1 413.4c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L203.3 256 349.4 109.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L192 244.7 45.9 98.6c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L180.7 256 34.6 402.1c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L192 267.3 338.1 413.4z"/></svg>
            </button>
        </template>
        <h5>Confirmation of vehicle bid</h5>
        <form @submit.stop.prevent>
            <messages :messages="messages"/>
            <div class="row">
                <div class="col-12">
                    By clicking 'Confirm', you acknowledge and agree to the following <br /> <br />
                    <ul>
                        <li>
                            You understand that no claims can be made on this vehicle due to the reason outlined below.
                            <br /><strong style="color: #2F6EBA;">{{ noClaimsReason }}</strong>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="mt-4 acceptance">
                    <b-form-group
                        id="input-group-2"
                        label=""
                        label-for="order_confirm"
                        :invalid-feedback="invalidField('noClaimsConfirm')"
                    >
                        <b-form-checkbox
                            id="order_confirm"
                            v-model="accepted"
                            :state="fieldState('noClaimsConfirm')"
                            required
                        >
                            You accept full responsibility for the vehicle and release SBL from any liability for current or future issues related to this reason.
                        </b-form-checkbox>
                    </b-form-group>
                </div>
            </div>
        </form>
        <template v-slot:modal-footer="{ ok, cancel, hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <div class="buttons">
                <b-button size="sm" variant="danger" @click="closeModal">
                    Cancel
                </b-button>
                <b-button type="submit" size="sm" variant="success" @click="confirmBid">
                    Confirm bid
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'NoClaimsModal',
    components: {
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        noClaimsReason: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            accepted: false,
            messages: []
        }
    },
    methods: {
        closeModal() {
            this.accepted = false
            this.$emit('close')
        },
        confirmBid() {
            this.messages = [];
            if (!this.accepted) {
                this.messages.push({type: 'danger', message: 'You must accept responsibility'})
                return
            }
            this.$emit('confirm')
            this.accepted = false
        },
        invalidField(field) {
            // This method should be implemented based on your validation logic
            // You might want to pass validation state as a prop or implement it here
            return ''
        },
        fieldState(field) {
            // This method should be implemented based on your validation logic
            // You might want to pass validation state as a prop or implement it here
            return null
        }
    }
}
</script>

<style scoped>
/* Add any component-specific styles here if needed */
</style> 


// WEBPACK FOOTER //
// resources/js/components/NoClaimsModal.vue